import { render, staticRenderFns } from "./CourseOtherItemForm.vue?vue&type=template&id=1e343281"
import script from "./CourseOtherItemForm.vue?vue&type=script&lang=js"
export * from "./CourseOtherItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports